import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import rootReducer from "./reducers/rootReducer";

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"], // ✅ Ignores redux-persist actions
            },
        }),
        devTools: process.env.REACT_APP_CMS_URL !== "production", // ✅ Disable DevTools in production
  });

const persistor = persistStore(store);

export { store, persistor };

